<template>
  <div>

    <!-- SUBLINKS PARA LOS REPORTES MANAGER EN EL SIDEBAR -->
    <li v-if="api.orderSubgroup === '1' & api.subgroup === 'agentes'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >AGENTES</a>
    </li>
    <li v-if="api.orderSubgroup === '1' & api.subgroup === 'skill'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >SKILL Y SERVICIOS</a>
    </li>
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'cdr'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >CDR</a>
    </li>
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'tipificacion'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >TIPIFICACIÓN</a>
    </li>
    <!-- <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'customer'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >CUSTOMER</a>
    </li> -->
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'diagrams_reports'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >DIAGRAMS REPORTS</a>
    </li>
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'calidad'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >CALIDAD</a>
    </li>
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'campanas_manager'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >CAMPAÑAS</a>
    </li>
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'chats_interacciones'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >CHATS E INTERACCIONES</a>
    </li>
    <li
    @click="saveIdAPI"
    >
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'general'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >API GENERAL</a>
    </li>
    <li
    @click="saveIdAPI"
    >
    <li li v-if="api.orderSubgroup === '1' & api.subgroup === 'casos'">
      <a 
      class="sublink-manager" 
      @click.prevent href="#" 
      style="color:#ff9917;"
      >API CASOS</a>
    </li>
    <li
    @click="saveIdAPI"
    >
        <!-- Rutas para cada uno lo links en la Sidebar -->
      <router-link
        :to="{
          name: api.groupAPI,
          params: {
            id: api.id,
          },
        }"
        :class="{active : api.id === $route.params.id }"
      >
        {{ api.title }}
      </router-link>
    </li>
  </div>
</template>
<script>
export default {
  name: "sublink",
  props: ["api", "id", "link"],
  methods:{
    saveIdAPI(){
      /*
      >Guardar el id de la API en el localStorage para despues renderizarlo en los componentes
      */
      if(localStorage.getItem('api') != null){
        localStorage.removeItem('api');
        localStorage.setItem('api', JSON.stringify(this.api))
      }else{
        localStorage.setItem('api', JSON.stringify(this.api))
      }
      // localStorage.setItem(this.api.id, 'id');
      // console.log(`Has guardado el id ${this.api.id}`)
    }
  }
};
</script>

<style>
a.sublink-manager{
  color:#ff9917;
}
</style>